<template>
  <div>
    <div class="settings-header">
      <h3 class="title-text">Try the new Audience Manager</h3>
      <p class="description-text">
        Experience a faster, smarter way to manage your audience — before it's officially released. 
        <!-- <a href="#" class="learn-more-link">Learn more</a> -->
      </p>
    </div>

    <div class="card-container">
      <div class="toggle-container">
        <div class="toggle-content">
          <p class="toggle-title">Join early access</p>
          <p v-if="isEarlyAccessEnabled" class="toggle-description">
            You have joined early access. Your changes will take effect the next time you reload the page.
          </p>
          
          <p v-else class="toggle-description">
            You have opted out of early access. Your changes will take effect the next time you reload the page.
          </p>
        </div>
        <am2-switch
          :value="isEarlyAccessEnabled"
          @input="updateToggleState"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getCookie, setCookie } from '@/utils/cookie.js';

export default {
  name: 'EarlyAccess',

  data() {
    return {
      isEarlyAccessEnabled: false
    };
  },

  created() {
    // Initialize toggle state based on cookie value
    const earlyAccessCookie = getCookie('am3EarlyAccessOptIn');
    if (earlyAccessCookie === 'true') {
      this.isEarlyAccessEnabled = true;
      console.log('Early access cookie found - initially enabled');
    } else {
      this.isEarlyAccessEnabled = false;
      console.log('Early access cookie not found or set to false - initially disabled');
    }
  },

  methods: {
    updateToggleState(value) {
      this.isEarlyAccessEnabled = value;
      
      if (value) {
        // User is opting in - set permanent cookie (no expiration date)
        setCookie('am3EarlyAccessOptIn', 'true', {
          path: '/'
          // No maxAge for permanent cookie
        });
        console.log('Early access enabled - cookie set to true');
      } else {
        // User is opting out - set cookie with 7-day expiration
        setCookie('am3EarlyAccessOptIn', 'false', {
          path: '/',
          maxAge: 60 * 60 * 24 * 7 // 7 days
        });
        console.log('Early access disabled - cookie set to false with 7-day expiration');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.settings-header {
  margin-bottom: 2rem;
}

.title-text {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  color: #111827;
}

.description-text {
  font-size: 0.875rem;
  color: #6B7280;
  max-width: 75%;
}

.learn-more-link {
  color: #6366F1;
  
  &:hover {
    text-decoration: underline;
  }
}

.card-container {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 0.375rem;
  // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  border: 1px solid #EDF1F5 ;
}

.toggle-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.toggle-content {
  flex: 1;
}

.toggle-title {
  font-size: 0.875rem;
  font-weight: bold;
  color: #111827;
}

.toggle-description {
  font-size: 0.75rem;
  color: #6B7280;
  margin-top: 1rem;
  max-width: 32rem;
  line-height: 1.25;
}
</style>